import React from 'react';

const CloseIcon = ({
  color = 'var(--font-color-second)',
  size = '1.5rem',
}: {
  color?: string;
  size?: string;
}) => (
  <svg
    style={{width: size, height: size}}
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.8002 7.2002L7.2002 16.8002"
      stroke={color}
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.2002 7.2002L16.8002 16.8002"
      stroke={color}
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CloseIcon;
